export const FLAG_GETTING_CABIN_CREW_CONTRACT_TYPES =
  'FLAG_GETTING_CABIN_CREW_CONTRACT_TYPES';
export const GET_CABIN_CREW_CONTRACT_TYPES = 'GET_CABIN_CREW_CONTRACT_TYPES';
export const CLEAR_CABIN_CREW_CONTRACT_TYPES =
  'CLEAR_CABIN_CREW_CONTRACT_TYPES';
